module.exports = "<div class=\"containerLogin\">\r\n    <div>\r\n        <img style=\"margin-right: 50px\" src=\"https://www.escondatagate.net/assets/autenticacion/img/logo-escon-2016.png\">\r\n        <img src=\"https://www.mibanco.com.co/upload/img/mibanco-blanco.png\">\r\n\r\n\r\n    </div>\r\n    <a (click)=\"openWindow()\" target=\"_blank\">ACCEDER</a>\r\n</div>\r\n"


//////////////////
// WEBPACK FOOTER
// C:/Users/Natalia.Morales/IdeaProjects/datagate/administrator/frontend/src/main/webapp/src/app/autenticacion/azureLogin/view/azureLogin.component.html
// module id = ../../../../../src/app/autenticacion/azureLogin/view/azureLogin.component.html
// module chunks = main